import { LocaleService } from "../services/locale.service";
import { Detail } from "./detail";
import { MenuItemDetailGroup } from "./menu-item";

export class DetailGroupPack 
{
    constructor(private localeservice:LocaleService)
    {

    }

    public DetailGroup: MenuItemDetailGroup = new MenuItemDetailGroup();

    public DetailList:Array<Detail> = new Array<Detail>();

    public LimitSelectionDescription:string = "";

    public ShowList=false;

    public HasSelection=false;

    detailTap(detail:Detail, amount:number = -1, macroAmount = 0)
    {
        if(detail.OutOfStock)
            return false;

        if(detail.Type == 0)
        {
            if(this.DetailGroup.LimitSelection === true && detail.CurrentCount === 0 && this.isMaxedOut())
                return false;

            if(detail.MaxCount === 1)
            {
                if(detail.CurrentCount === detail.MaxCount)
                    detail.CurrentCount = 0;
                else
                    detail.CurrentCount = 1;
            }
            else if(detail.MaxCount > 1)
            {
                if(amount === -1)
                {
                    if(detail.CurrentCount === detail.MaxCount)
                        detail.CurrentCount = 0;
                    else
                        detail.CurrentCount += 1;
                }
                else
                {
                    if(amount < 0)
                        amount = 0;

                    if(amount > detail.MaxCount)
                        amount == detail.MaxCount;

                    detail.CurrentCount = amount;
                }
            }
            else
            {
                this.updateHasSelection();

                return false;
            }

            this.updateHasSelection();

            return true;
        }
        else if(detail.Type == 1)
        {
            this.deselectAll();

            detail.CurrentCount = 1;

            this.updateHasSelection();

            return true;
        }

        return false;
    }

    updateHasSelection()
    {
        var selected = this.DetailList.find(x => x.CurrentCount > 0);

        this.HasSelection = selected != undefined;
    }

    reset()
    {
        if(this.DetailList != null && this.DetailList != undefined)
        {
            for (let index = 0; index < this.DetailList.length; index++) 
            {
                const detail = this.DetailList[index];
                
                detail.CurrentCount = detail.DefaultCount;
            }
        }

        this.updateHasSelection();
    }

    getRemainingSelections(macroAmount:number)
    {
        var remaining = this.DetailGroup.MacroMaxSelectionCount - macroAmount;

        if(this.DetailGroup.LimitSelection)
        {
            var localRemaining = this.DetailGroup.MaxSelectionCount - this.getSelectionCount();

            if(remaining > localRemaining)
                return localRemaining;
        }

        return remaining;
    }

    updateLimitSelectionDescription(macroAmount:number = 0, macroMinimum = 0)
    {
        var remaining = this.getRemainingSelections(macroAmount);

        this.LimitSelectionDescription = `${remaining} ${this.localeservice.instantTranslation("SelectionLimitDescription.Remaining")}.`;

        var minimum = macroMinimum;

        if(minimum > 0 && macroAmount < minimum)
        {
            if(this.DetailGroup.MinSelectionCount > minimum)
                minimum = this.DetailGroup.MinSelectionCount;

            this.LimitSelectionDescription += ` (${this.localeservice.instantTranslation("SelectionLimitDescription.Minimum")} ${minimum})`
        }
    }

    deselectAll()
    {
        if(this.DetailList != null && this.DetailList != undefined)
        {
            for (let index = 0; index < this.DetailList.length; index++) 
            {
                const detail = this.DetailList[index];
                
                detail.CurrentCount = 0;
            }
        }
    }

    getCurrentPrice()
    {
        let currentPrice = 0;

        for (let index = 0; index < this.DetailList.length; index++) 
        {
            const detail = this.DetailList[index];

            if(detail.HasValue)
                currentPrice += detail.Price * detail.CurrentCount;
        }

        return currentPrice;
    }

    getValidation()
    {
        if(this.DetailGroup.Type === 0)
            return this.getSelectionCount() >= this.DetailGroup.MinSelectionCount;

        if(this.DetailGroup.Type === 1)
        {
            let selected = this.DetailList.find(detail => detail.CurrentCount === 1)

            return selected !== undefined;
        }

        return true;
    }

    clearForSubmission()
    {
        for (let index = 0; index < this.DetailList.length; index++) 
        {
            const detail = this.DetailList[index];
            
            if(detail.CurrentCount === 0)
            {
                for (let index = 0; index < this.DetailGroup.CurrentDetailIDList.length; index++) 
                {
                    const detailID = this.DetailGroup.CurrentDetailIDList[index];
                    
                    if(detail.ID === detailID)
                    {
                        this.DetailGroup.CurrentDetailIDList.splice(index, 1);

                        break;
                    }
                }

                this.DetailList.splice(index, 1);

                index--;
            }
        }
    }

    getVerficationCount()
    {
        return this.DetailList.length;
    }

    setRelation(orderID:string, menuItemID:string)
    {
        for (let index = 0; index < this.DetailList.length; index++) 
        {
            const detail = this.DetailList[index];
            
            detail.OrderID = orderID;
            detail.ItemID = menuItemID;
            detail.GroupID = this.DetailGroup.ID;
        }
    }

    getSelectionCount()
    {
        let count = 0;

        this.DetailList.forEach(x => count += x.CurrentCount);

        return count;
    }

    public isMaxedOut()
    {
        if(this.DetailGroup.Type === 1)
        {
            let selected = this.DetailList.find(detail => detail.CurrentCount === 1)

            return selected !== undefined;
        }

        if(this.DetailGroup.Type === 0)
        {
            if(this.DetailGroup.LimitSelection === true)
                return this.getSelectionCount() === this.DetailGroup.MaxSelectionCount;
            else
                return this.getSelectionCount() === this.DetailList.filter(x => !x.OutOfStock).length;
        }

        return false;
    }

    public HasDefault()
    {
        var hasDefaultCount = this.DetailList.find(x => x.DefaultCount > 0);

        return hasDefaultCount !== undefined;
    }
}
